<template>
  <v-app>
    <Navbar v-if="$route.path != '/' && $route.path != '/forgotPassword'" />
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-row justify="center">
      <v-alert
        v-if="success"
        style="position: absolute; top: 50%; z-index: 999"
        type="success"
        >{{ message }}</v-alert
      >
      <v-alert
        v-if="error"
        style="position: absolute; top: 50%; z-index: 999"
        type="error"
        >{{ message }}</v-alert
      >
    </v-row>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: { Navbar },
  data() {
    return {};
  },
  methods: {
    assignUserType() {
      // localStorage.setItem('userType', "users");
      // localStorage.removeItem("userType");
    },
  },
  created() {
    // this.assignUserType();
  },
  computed: {
    success() {
      return this.$store.state.success;
    },
    error() {
      return this.$store.state.error;
    },
    message() {
      return this.$store.state.message;
    },
  },
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0px !important;
}

.v-text-field .v-input__slot {
  border-radius: 5px 0px 0px 5px !important;
}
.v-data-table-header {
  background-color: #343434;
  border-radius: 12px 20px 0px 0px;
  color: white;
}
.v-data-table-header span {
  color: white;
}
.v-data-table-header-mobile th {
  border-radius: 13px;
}

th:nth-child(1) {
  border-radius: 4px 0px 0px 0px;
}

th:last-child {
  border-radius: 0px 4px 0px 0px;
}

v-data-table-header-mobile th {
  border-radius: 13px !important;
}
.v-data-table tbody tr:nth-child(2n) {
  background-color: #f6f6f6;
}
.v-input__append-inner {
  opacity: 0;
}
.v-data-table {
  color: black;
  box-shadow: 0px 0px 0px 1px lightslategray;
}
</style>
